export const ARE_EVENTS_LOADING = 'areEventsLoading';
